import React, { useState, useEffect } from 'react';

const CartDrawer = () => {
  const [cart, setCart] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Загрузка корзины
  const fetchCart = async () => {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      setCart(cartData);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  };

  // Обновление количества товара
  const updateQuantity = async (variantId, quantity) => {
    setLoading(true);
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: { [variantId]: quantity }
        })
      });
      
      if (response.ok) {
        await fetchCart();
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
    setLoading(false);
  };

  // Удаление товара
  const removeItem = async (variantId) => {
    await updateQuantity(variantId, 0);
  };

  // Форматирование цены
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price / 100);
  };

  useEffect(() => {
    fetchCart();
    
    // Слушаем события обновления корзины
    const handleCartUpdate = () => {
      fetchCart();
      setIsOpen(true);
    };
    
    document.addEventListener('cart:updated', handleCartUpdate);
    
    // Слушаем клики по иконке корзины
    const cartIcon = document.querySelector('[data-cart-icon]');
    if (cartIcon) {
      cartIcon.addEventListener('click', () => setIsOpen(true));
    }

    return () => {
      document.removeEventListener('cart:updated', handleCartUpdate);
    };
  }, []);

  if (!cart) return null;

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 9998
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
      
      {/* Cart Drawer */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          right: isOpen ? 0 : '-400px',
          width: '400px',
          height: '100%',
          backgroundColor: 'white',
          zIndex: 9999,
          transition: 'right 0.3s ease',
          boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '20px',
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px' }}>
            Your Cart ({cart.item_count})
          </h3>
          <button
            onClick={() => setIsOpen(false)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer'
            }}
          >
            ×
          </button>
        </div>

        {/* Cart Items */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
          {cart.items.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#666' }}>
              Your cart is empty
            </p>
          ) : (
            cart.items.map(item => (
              <div key={item.key} style={{
                display: 'flex',
                marginBottom: '20px',
                paddingBottom: '20px',
                borderBottom: '1px solid #f0f0f0'
              }}>
                {item.image && (
                  <img 
                    src={item.image}
                    alt={item.title}
                    style={{
                      width: '60px',
                      height: '60px',
                      objectFit: 'cover',
                      borderRadius: '4px',
                      marginRight: '12px'
                    }}
                  />
                )}
                
                <div style={{ flex: 1 }}>
                  <h4 style={{ margin: '0 0 4px 0', fontSize: '14px' }}>
                    {item.title}
                  </h4>
                  {item.variant_title && (
                    <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#666' }}>
                      {item.variant_title}
                    </p>
                  )}
                  
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <button
                        onClick={() => updateQuantity(item.variant_id, item.quantity - 1)}
                        disabled={loading}
                        style={{
                          width: '30px',
                          height: '30px',
                          border: '1px solid #ccc',
                          background: 'white',
                          cursor: 'pointer'
                        }}
                      >
                        -
                      </button>
                      <span style={{ margin: '0 12px', minWidth: '20px', textAlign: 'center' }}>
                        {item.quantity}
                      </span>
                      <button
                        onClick={() => updateQuantity(item.variant_id, item.quantity + 1)}
                        disabled={loading}
                        style={{
                          width: '30px',
                          height: '30px',
                          border: '1px solid #ccc',
                          background: 'white',
                          cursor: 'pointer'
                        }}
                      >
                        +
                      </button>
                    </div>
                    
                    <div>
                      <span style={{ fontWeight: '600' }}>
                        {formatPrice(item.final_line_price)}
                      </span>
                      <button
                        onClick={() => removeItem(item.variant_id)}
                        style={{
                          marginLeft: '12px',
                          background: 'none',
                          border: 'none',
                          color: '#ff4444',
                          cursor: 'pointer'
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {cart.items.length > 0 && (
          <div style={{
            padding: '20px',
            borderTop: '1px solid #e0e0e0'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '16px',
              fontSize: '18px',
              fontWeight: '600'
            }}>
              <span>Total:</span>
              <span>{formatPrice(cart.total_price)}</span>
            </div>
            
            <button
              onClick={() => window.location.href = '/cart'}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#2c5aa0',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                marginBottom: '8px'
              }}
            >
              View Cart
            </button>
            
            <button
              onClick={() => window.location.href = '/checkout'}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Checkout
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CartDrawer;